import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'

import { tokenStore } from '@/lib/api/tokenStore'

import { buildLoginPath } from './returnTo'

/**
 * 세션이 없으면 로그인으로 보낸다.
 * 🚨 판정 기준은 `tokenStore.hasValidSession()` 하나다(설계 불변식 1).
 */
export function ProtectedRoute({ children }: { children: ReactNode }) {
  const location = useLocation()

  if (!tokenStore.hasValidSession()) {
    return <Navigate to={buildLoginPath(`${location.pathname}${location.search}`)} replace />
  }
  return <>{children}</>
}
